import { render, staticRenderFns } from "./report_promotion.vue?vue&type=template&id=1a8daef0&"
import script from "./report_promotion.vue?vue&type=script&lang=js&"
export * from "./report_promotion.vue?vue&type=script&lang=js&"
import style0 from "./report_promotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports